import { render, staticRenderFns } from "./SitesTable.vue?vue&type=template&id=12a625f4&"
import script from "./SitesTable.vue?vue&type=script&lang=js&"
export * from "./SitesTable.vue?vue&type=script&lang=js&"
import style0 from "./SitesTable.vue?vue&type=style&index=0&id=12a625f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports